import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHorizontalBarChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2152_14920)",
		children: /* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip1_2152_14920)",
			children: /* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip2_2152_14920)",
				children: [/* @__PURE__ */ _jsx("mask", {
					id: "mask0_2152_14920",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 2,
					y: 2,
					width: 28,
					height: 28,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M29.1279 2.62885L29.1279 29.374L2.87328 29.374L2.87328 2.62885L29.1279 2.62885Z",
						fill: "white"
					})
				}), /* @__PURE__ */ _jsxs("g", {
					mask: "url(#mask0_2152_14920)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M2.87287 26.295L2.87287 28.7582C2.87287 29.1031 3.13542 29.374 3.46957 29.374H8.24314C9.23365 29.374 10.0332 28.5488 10.0332 27.5266C10.0332 26.5043 9.23365 25.6792 8.24314 25.6792H3.46957C3.13542 25.6792 2.87287 25.9501 2.87287 26.295ZM4.06627 28.1424L4.06627 26.9108H8.24314C8.57729 26.9108 8.83984 27.1817 8.83984 27.5266C8.83984 27.8714 8.57729 28.1424 8.24314 28.1424H4.06627Z",
							fill: "currentColor"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M2.87359 20.5322V22.9955C2.87359 23.3404 3.13614 23.6113 3.47029 23.6113L15.4042 23.6113C16.3947 23.6113 17.1943 22.7861 17.1943 21.7639C17.1943 20.7416 16.3947 19.9164 15.4042 19.9164L3.47029 19.9164C3.13614 19.9164 2.87359 20.1874 2.87359 20.5322ZM4.06699 22.3797V21.1481L15.4042 21.1481C15.7384 21.1481 16.0009 21.419 16.0009 21.7639C16.0009 22.1087 15.7384 22.3797 15.4042 22.3797L4.06699 22.3797Z",
							fill: "currentColor"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M2.87367 14.7705V17.2338C2.87367 17.5787 3.13623 17.8496 3.47037 17.8496L13.0175 17.8496C14.008 17.8496 14.8076 17.0244 14.8076 16.0022C14.8076 14.9799 14.008 14.1547 13.0175 14.1547L3.47037 14.1547C3.13623 14.1547 2.87367 14.4257 2.87367 14.7705ZM4.06708 16.618V15.3863L13.0175 15.3863C13.3517 15.3863 13.6142 15.6573 13.6142 16.0022C13.6142 16.347 13.3517 16.618 13.0175 16.618L4.06708 16.618Z",
							fill: "currentColor"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M2.87327 9.00684V11.4701C2.87327 11.8149 3.13582 12.0859 3.46997 12.0859L27.3378 12.0859C28.3284 12.0859 29.1279 11.2607 29.1279 10.2385C29.1279 9.21624 28.3284 8.39106 27.3378 8.39106L3.46997 8.39106C3.13582 8.39106 2.87327 8.66201 2.87327 9.00684ZM4.06667 10.8543V9.62267L27.3378 9.62267C27.672 9.62267 27.9345 9.89362 27.9345 10.2385C27.9345 10.5833 27.672 10.8543 27.3378 10.8543L4.06667 10.8543Z",
							fill: "currentColor"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M2.87341 3.24512V5.70839C2.87341 6.05322 3.13592 6.32422 3.47011 6.32422L22.5644 6.32422C23.5549 6.32422 24.3545 5.49899 24.3545 4.47678C24.3545 3.45452 23.5549 2.62934 22.5644 2.62934L3.47011 2.62934C3.13592 2.62934 2.87341 2.90029 2.87341 3.24512ZM4.06677 5.09256V3.86095L22.5644 3.86095C22.8985 3.86095 23.1611 4.1319 23.1611 4.47678C23.1611 4.82161 22.8985 5.09256 22.5644 5.09256L4.06677 5.09256Z",
							fill: "currentColor"
						})
					]
				})]
			})
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2152_14920",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 28,
				height: 28,
				fill: "white",
				transform: "matrix(0 -1 -1 0 30 30)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_2152_14920",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 28,
				height: 28,
				fill: "white",
				transform: "matrix(0 -1 -1 0 30 30)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip2_2152_14920",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 28,
				height: 27.5692,
				fill: "white",
				transform: "matrix(0 -1 -1 0 29.7842 30)"
			})
		})
	] })]
});
export default SvgHorizontalBarChart;
